// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import './CitationChip.css';

/** Small source tag (SOP, Manual, ...) shown inline after chat answers and brief causes. */
export default function CitationChip({ label, suspect }: { label: string; suspect?: boolean }) {
  return (
    <span className={`akh-inline-cite${suspect ? ' akh-inline-cite-suspect' : ''}`}>
      {suspect && (
        <>
          <span aria-hidden="true">⚠ </span>
          <span className="akh-visually-hidden">Unverified source: </span>
        </>
      )}
      {label}
    </span>
  );
}
